// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yr0f","index":"styles_index__3eKHo"};